import { CurrencyFormatter } from '@mixins/currency-formatter-mixin';
import { format } from '@mixins/date-formatter-mixin';
import Branch from '@models/branch';
import Contact from '@models/contact';
// eslint-disable-next-line import/no-cycle
import Customer, { CUSTOMER_STATUS_ON_HOLD, CUSTOMER_STATUS_PAST_DUE } from '@models/customer';
import Model from '@models/model';

import ApiClient from '@/api-client';

export default class CustomerLocation extends Model {
    static className = 'CustomerLocation';

    index = true;

    yaypay = true;

    delivery_branch = new Branch();

    service_branch = Branch;

    primary_delivery_contact = Contact;

    customer = Customer;

    proposal_term = {};

    static allowsEdit = true;

    static allowedFieldEdits = [
        'delivery_address_line_1',
        'delivery_address_line_2',
        'delivery_city',
        'delivery_state',
        'delivery_zip',
    ];

    resource() {
        return 'locations';
    }

    relations() {
        return {
            delivery_branch: Branch,
            service_branch: Branch,
            primary_delivery_contact: Contact,
            customer: Customer,
        };
    }

    get formFieldCasts() {
        return {
            labor_surcharge_amount: CurrencyFormatter.formFormat,
            fuel_surcharge_amount: CurrencyFormatter.formFormat,
            trip_surcharge_amount: CurrencyFormatter.formFormat,
            service_prevailing_wage_surcharge_amount: CurrencyFormatter.formFormat,
            delivery_prevailing_wage_surcharge_amount: CurrencyFormatter.formFormat,
            mobile_trip_surcharge_amount: CurrencyFormatter.formFormat,
            cancellation_date: [format, 'YYYY-MM-DD'],
        };
    }

    setDeliveryAddress(address) {
        this.delivery_address_line_1 = address.address_line_1;
        this.delivery_address_line_2 = address.address_line_2;
        this.delivery_city = address.city;
        this.delivery_state = address.state;
        this.delivery_zip = address.zip;
    }

    get displayName() {
        return this.name || this.delivery_address_line_2 || this.delivery_address_line_1;
    }

    get billingAddressFormatted() {
        if (!this.billing_address_line_1) return '';
        return `${this.billing_address_line_1}<br>
                ${this.billing_address_line_2 ? `${this.billing_address_line_2}<br>` : ''}
                ${this.billing_city}, ${this.billing_state} ${this.billing_zip}`;
    }

    get customerCode() {
        return `${this.customer_id}-${this.code}`;
    }

    get deliveryAddressFormatted() {
        if (!this.delivery_address_line_1) return '';
        return `${this.delivery_address_line_1}<br>
                ${this.delivery_address_line_2 ? `${this.delivery_address_line_2}<br>` : ''}
                ${this.delivery_city}, ${this.delivery_state} ${this.delivery_zip}`;
    }

    async getGeoCodes(address) {
        const response = await ApiClient.get('/api/geocodes', { params: { address } });

        return {
            lat: response.data.latitude,
            lng: response.data.longitude,
        };
    }

    static async getFinancials(customerId, locationId) {
        const response = await this.api().get(`/api/customers/${customerId}/locations/${locationId}/financials`);

        return response.data;
    }

    get isOnHold() {
        return this.status === CUSTOMER_STATUS_ON_HOLD;
    }

    get isPastDue() {
        return this.status === CUSTOMER_STATUS_PAST_DUE;
    }
}
